<template>
    <div
        class="rounded ring-1 overflow-hidden transition-all duration-150 lg:hover:ring-green-600 mb-3 md:mb-0"
        :class="[isActive?'ring-green-600':'ring-gray-100']"
    >
        <label :class="{'cursor-pointer':cursorPointer}">
            <div class="p-2.5 bg-green-100">
                <slot name="input" />
            </div>
            <div
                class="p-2.5 border-t text-base xs:text-lg transition-all duration-150"
                :class="[isActive?'border-green-600':'border-gray-100']"
            >
                <slot name="content" />
            </div>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        cursorPointer: {
            type: Boolean,
            default: true
        }
    },
};
</script>
